exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comments-component{padding-bottom:60px;background-color:#f0f0f0;min-height:100vh}.comments-component .fz-12{font-size:12px}.comments-component .text-gray{color:#999}.comments-component .comment.bg-white{background-color:#fff;padding:30px;margin:0;border-top:1px solid #e5eaeb}.comments-component .comment.bg-white .comment-avatar{float:left;width:40px;height:40px;padding:5px;border-radius:40px;border:1px solid #e5eaeb}.comments-component .comment.bg-white .comment-meta h4{font-size:14px;font-weight:700;line-height:40px;margin-left:10px;margin-bottom:0;vertical-align:middle}.comments-component .comment.bg-white .comment-meta .text-gray.float-right{line-height:40px}.comments-component .comment.bg-white .comment-content{color:#777;margin-top:10px;margin-bottom:0;text-align:justify}.comments-component .comment.bg-white .score{margin-top:10px}.comments-component .empty{text-align:center;padding-top:50px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Comments.scss
// module id = 633
// module chunks = 0